import _ from 'lodash';
import {
  LOAD_USER_ACTIVITY_SETTINGS_FAILURE,
  LOAD_USER_ACTIVITY_SETTINGS_SUCCESS,
  UPDATE_PREFERENCE_SETTINGS,
} from 'common/notifications/actions/PreferenceActions';

import { handleLoadUserActivitySettingsSuccess } from 'common/user_activity/reducers';

const initialState = {
  userActivitySettings: {
    loadingState: true,
    featureEnabled: false,
    sendEmailToInactiveUser: false,
  },
};

function handleLoadUserActivitySettingsFailure(state = {}, error) {
  return {
    ...state,
    userActivitySettings: {
      loadingState: false,
      hasError: true,
    },
  };
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_PREFERENCE_SETTINGS:
      const settings = _.get(action, 'preferenceSettings.settings', {});
      const transientNotificationsSettings = _.find(settings, (setting) => {
        return setting[0].name === 'transient_notification';
      });

      return {
        ...state,
        ...action.preferenceSettings,
        isTransientNotificationEnabled: _.get(transientNotificationsSettings, '[0].enable', true),
      };
    case LOAD_USER_ACTIVITY_SETTINGS_SUCCESS:
      return {
        ...state,
        userActivitySettings: {
          ...handleLoadUserActivitySettingsSuccess({}, action.payload),
          hasError: false,
        },
      };
    case LOAD_USER_ACTIVITY_SETTINGS_FAILURE:
      return {
        ...state,
        userActivitySettings: handleLoadUserActivitySettingsFailure({}, action.error),
      };
    default:
      return state;
  }
}
